import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';
import { useExperiment } from '@nerdwallet/features';
import { setTrk } from '@nerdwallet/nw-client-lib/trk-helper';

import { Box, Type, Button } from '@nerdwallet/currency';
import analytics from '@nerdwallet/analytics';
import { trackInteraction } from '../../../lib/analytics-helpers';

import styles from './vertical-comparison.module.less';

const VerticalComparisonTab = ({
  id,
  subtitle,
  description,
  primaryButtonText,
  primaryButtonUrl,
  secondaryButtonText,
  secondaryButtonUrl,
  abTestOverrides,
}) => {
  const { assignedVariantName, loading } = useExperiment({
    testName: abTestOverrides?.testName || '',
  });
  const [primaryUrl, setPrimaryUrl] = useState();

  const primaryEntityName = `hp_${id}_tab_primary_cta_clicked`;
  const primaryImpressionId = analytics.uuid();

  const secondaryEntityName = `hp_${id}_tab_secondary_cta_clicked`;
  const secondaryImpressionId = analytics.uuid();

  useEffect(() => {
    const activeVariant = abTestOverrides?.variants.find(
      (variant) => assignedVariantName === variant.variantName
    );

    const getAbTestPrimaryUrl = () => {
      return activeVariant.variantName === 'control'
        ? activeVariant.url
        : setTrk(activeVariant);
    };

    setPrimaryUrl(activeVariant ? getAbTestPrimaryUrl() : primaryButtonUrl);
  }, [abTestOverrides, assignedVariantName, primaryButtonUrl]);

  if (loading) return null;

  return (
    <Box className={classNames(styles.backgroundImage)}>
      <Box className={classNames(styles.contentWrapper)}>
        <Box className={classNames(styles.contentBox)}>
          <Type bold className={classes('margin-bottom-3')}>
            {subtitle}
          </Type>
          <Type className={classes('margin-bottom-4')}>{description}</Type>
          <div className={styles.buttonWidth}>
            <Button
              primary
              block
              href={primaryUrl}
              onClick={() =>
                trackInteraction(primaryEntityName, primaryImpressionId)
              }
            >
              {primaryButtonText}
            </Button>
          </div>
          <div className={styles.buttonWidth}>
            <Button
              secondary
              block
              href={secondaryButtonUrl}
              onClick={() =>
                trackInteraction(secondaryEntityName, secondaryImpressionId)
              }
            >
              {secondaryButtonText}
            </Button>
          </div>
        </Box>
      </Box>
    </Box>
  );
};

VerticalComparisonTab.propTypes = {
  id: PropTypes.string,
  subtitle: PropTypes.string,
  description: PropTypes.string,
  primaryButtonText: PropTypes.string,
  primaryButtonUrl: PropTypes.string,
  secondaryButtonText: PropTypes.string,
  secondaryButtonUrl: PropTypes.string,
  abTestOverrides: PropTypes.shape({
    testName: PropTypes.string,
    variants: PropTypes.arrayOf(
      PropTypes.shape({
        variantName: PropTypes.string,
        url: PropTypes.string,
        params: PropTypes.shape({
          trk_ab_test: PropTypes.string,
          trk_ab_test_variant: PropTypes.string,
        }),
      })
    ),
  }),
};

PropTypes.defaultProps = {
  abTestOverrides: {
    testName: '',
    variants: [
      {
        variantName: '',
        url: '',
        params: {
          trk_ab_test: '',
          trk_ab_test_variant: '',
        },
      },
    ],
  },
};

VerticalComparisonTab.displayName = 'VerticalComparisonTab';

export default VerticalComparisonTab;
